export const REFERENCE_TABLE = {
	1: 'C3',
	2: 'D3',
	3: 'E3',
	4: 'F3',
	5: 'G3',
	6: 'A3',
	7: 'B3',
	8: 'C4',
	9: 'D4',
	10: 'E4',
	11: 'F4',
	12: 'G4',
	13: 'A4',
	14: 'B4'
}; 



// WEBPACK FOOTER //
// ./D:/Repos/university/my-composer/app/players/common.js